import { ACADEMIC_PAGE_CONFIG } from './academic.config';
import { CAREER_PAGE_CONFIG } from './career.config';
import { DOCUMENTS_PAGE_CONFIG } from './documents.config';
import { FINANCIAL_PAGE_CONFIG } from './financial.config';
import { HEALTH_PAGE_CONFIG } from './health.config';
import { INTERESTS_PAGE_CONFIG } from './interest.config';
import { PROFILE_PAGE_CONFIG } from './profile.config';
import { RELATIONSHIPS_PAGE_CONFIG } from './relationship.config';

export const PAGE_CONFIGS = {
  Profile: PROFILE_PAGE_CONFIG,
  Academics: ACADEMIC_PAGE_CONFIG,
  Career: CAREER_PAGE_CONFIG,
  Interests: INTERESTS_PAGE_CONFIG,
  Relationships: RELATIONSHIPS_PAGE_CONFIG,
  Health: HEALTH_PAGE_CONFIG,
  Finances: FINANCIAL_PAGE_CONFIG,
  Documents: DOCUMENTS_PAGE_CONFIG,
} as const;

export type PageName = keyof typeof PAGE_CONFIGS;
